export default {
      id: "icon-envelope-box-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-envelope-box",
      toString: function () {
        return this.url;
      }
    }